/**
 * Dashboard feature flags.
 */

/**
 * Whether to render the creative-markets stories shelf.
 *
 * Off unless explicitly enabled. The shelf has no data source yet: it previously
 * rendered a synthetic fixture attributed to real publishers, which shipped to
 * the live dashboard. That fixture has since been deleted and StoriesCard now
 * requires its `items`, so there is nothing to fall back to.
 *
 * Turn on with `VITE_ENABLE_STORIES_FEED=true` once
 * `GET /api/v3/feeds/aggregate` exists and the route passes its result as
 * `items`. Default-off means a build that forgets the flag hides an empty shelf
 * rather than showing one.
 */
export function isStoriesFeedEnabled(): boolean {
  return String(import.meta.env.VITE_ENABLE_STORIES_FEED ?? '')
    .trim()
    .toLowerCase() === 'true';
}
